module.exports = new __parcel__URL__("germany-flag.5fadc030.svg").toString();